import { createContext, useContext } from "react";

import type { ActiveEvent } from "@/types/events";

/**
 * Contexto do evento ativo e o hook que o lê. O `<EventProvider>` mora em `EventContext.tsx`.
 *
 * Fica fora do arquivo do componente de propósito: o Fast Refresh do Vite só preserva o estado
 * ao editar um arquivo que exporta APENAS componentes. Hook e componente juntos forçavam
 * recarga completa da página a cada edição (aviso react-refresh/only-export-components).
 */
export interface EventContextValue {
  event: ActiveEvent | null;
  eventId: number | null;
  isLoading: boolean;
  /** Invalida o cache do evento ativo — chamar depois de editar o evento
   *  (nome, etc.) em `/evento`, já que o legado resolve isso uma vez e
   *  reusa; aqui o equivalente é `staleTime` alto + invalidação explícita. */
  invalidate: () => void;
}

export const EventContext = createContext<EventContextValue | null>(null);

export function useActiveEvent(): EventContextValue {
  const ctx = useContext(EventContext);
  if (!ctx) {
    throw new Error("useActiveEvent precisa ser usado dentro de <EventProvider>.");
  }
  return ctx;
}
